import { motion, AnimatePresence } from "framer-motion";
import { useGame } from "../context/GameContext.jsx";
import { useLanguage } from "../hooks/useLanguage.js";
import { fadeIn, scaleIn } from "../animations/variants.js";
import { Btn } from "../components/ui/Btn.jsx";
import { RoleCardFull } from "../components/role/RoleCardFull.jsx";

export function RoleRevealScreen() {
  const { state, dispatch } = useGame();
  const { lang } = useLanguage();
  const current = state.revealQueue[state.revealIndex];
  const player = state.session?.players.find(p => p.id === current?.playerId);
  const total = state.revealQueue.length;
  const isLast = state.revealIndex >= total - 1;

  if (!current || !player) return null;

  return (
    <motion.div variants={fadeIn} initial="initial" animate="animate" exit="exit"
      className="min-h-screen bg-gradient-to-b from-stone-950 to-amber-950 flex flex-col">

      <div className="px-4 pt-10 pb-4">
        <div className="flex gap-1">
          {state.revealQueue.map((_, i) => (
            <div key={i} className={`h-1 flex-1 rounded-full transition-all
              ${i < state.revealIndex ? "bg-amber-500" : i === state.revealIndex ? "bg-amber-200" : "bg-amber-900/30"}`} />
          ))}
        </div>
        <p className="text-amber-600/50 text-xs text-center mt-2">{state.revealIndex + 1} / {total}</p>
      </div>

      <div className="flex-1 flex flex-col items-center justify-center px-6 pb-4">
        <AnimatePresence mode="wait">
          {!state.revealShown ? (
            <motion.div key="pass" variants={scaleIn} initial="initial" animate="animate" exit="exit"
              className="w-full max-w-xs flex flex-col items-center gap-6">
              <div className="w-32 h-32 rounded-3xl bg-stone-900/80 border-2 border-amber-800/30 flex flex-col items-center justify-center">
                <span className="text-5xl">🃏</span>
                <span className="text-amber-700/40 text-[9px] uppercase tracking-widest mt-1">{lang === "fr" ? "Rôle" : "Role"}</span>
              </div>
              <div className="text-center">
                <p className="text-amber-500/60 text-xs uppercase tracking-widest mb-1">{lang === "fr" ? "Passe le téléphone à" : "Pass the phone to"}</p>
                <p className="text-amber-200 font-bold text-3xl">{player.name}</p>
              </div>
              <Btn variant="primary" size="lg" onClick={() => dispatch({ type: "SHOW_CARD" })} className="w-full">
                {lang === "fr" ? "👁 Révéler mon rôle" : "👁 Reveal my role"}
              </Btn>
            </motion.div>
          ) : (
            <motion.div key="card" variants={scaleIn} initial="initial" animate="animate" exit="exit"
              className="w-full max-w-xs flex flex-col gap-6">
              <RoleCardFull roleId={current.roleId} playerName={player.name} lang={lang} />
              <Btn variant={isLast ? "primary" : "secondary"} size="lg" onClick={() => dispatch({ type: "NEXT_REVEAL" })} className="w-full">
                {isLast ? (lang === "fr" ? "🌙 Commencer la partie" : "🌙 Start the game") : (lang === "fr" ? "Joueur suivant →" : "Next player →")}
              </Btn>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </motion.div>
  );
}
